// @flow
import * as React from 'react';

import type { FavoriteContact } from '@gandi/redux-resource-contactbook';
import { useTranslator } from '@gandi/translate';
import { Base, Text } from '@gandi/ui';

import { getDisplayedType, getDisplayName } from '../../../../modules/helpers';

type Props = {
  contact: FavoriteContact,
};

const ContactName = ({ contact }: Props): React.MixedElement => {
  const translator = useTranslator();

  return (
    <>
      <Base flex marginY="none">
        <Text weight="semibold" transform="capitalize">
          {getDisplayName(contact)}
        </Text>
      </Base>

      <Base flex marginTop="none" marginBottom="none">
        <Text weight="semibold">{contact.email}</Text>
      </Base>

      <Base flex marginTop="none">
        <Text transform="uppercase" color="light" size="small">
          {getDisplayedType(translator, contact.type)}
        </Text>
      </Base>
    </>
  );
};

export default (React.memo<Props>(ContactName): React.ComponentType<Props>);
